/** 語系 */
export enum Locale {
  /** 英文 */
  EN_US = 'EN-US',
  /** 繁體中文 */
  ZH_TW = 'ZH-TW',
  /** 越南 */
  VI_VN = 'VI-VN'
}
